<template>
    <header class="d-flex flex-row text-light p-0 justify-content-between align-items-center px-4">
        <div class="findDevice d-flex flex-row py-1 px-2 rounded align-items-center">
            <img src="@/assets/img/find.svg" class="me-2">
            <input @keyup="findDevice" type="text" v-model="text" class="text-light border-none" placeholder="Buscar Unidad:">
        </div>
        <MenuHeader></MenuHeader>
    </header>
</template>
    
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import MenuHeader from '@/components/headers/MenuHeader.vue'
import devicesModule from '@/store/modules/devices.module';

@Component({
    components: {
        MenuHeader
    }
})
export default class DevicesHeader extends Vue {
    text = ''
    findDevice(){
        devicesModule.setFilterDevice(this.text.toUpperCase())
    }

}
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables.sass'

.findDevice
    background: $secondary
    width: 90%
    input
        background: $secondary
        border: none
        width: 90%
        &:focus-visible
            border: none
            outline: none
        &::placeholder
            color: rgba(255, 255, 255, 0.80)
            
    img
        height: 20px

header
    background: $primary
    height: 60px
    img
        height: 20px
    .logo
        height: 50px
</style>
    